export const Types = {
  INVOICE_ERROR: "invoice/invoice_error",
  GET_INVOICES: "invoice/get_invoices",
  GET_INVOICES_SUCCESS: "invoice/get_invoices_success",
  GET_INVOICES_RESET: "invoice/get_invoices_reset",
  GET_INVOICE_PDF: "invoice/get_invoice_pdf",
  GET_INVOICE_PDF_SUCCESS: "invoice/get_invoice_pdf_success",
  MARK_INVOICE_PAYED: "invoice/mark_invoice_payed",
  GET_INVOICE_TYPES: "invoice/get_invoice_types",
  GET_INVOICE_TYPES_SUCCESS: "invoice/get_invoice_types_success",
};

export const getInvoicePdf = (invoiceId) => ({
  type: Types.GET_INVOICE_PDF,
  payload: { invoiceId },
});

export const getInvoicePdfSuccess = (invoiceId) => ({
  type: Types.GET_INVOICE_PDF_SUCCESS,
  payload: { invoiceId },
});

export const getInvoiceTypes = () => ({
  type: Types.GET_INVOICE_TYPES,
});

export const getInvoiceTypesSuccess = (invoiceTypes) => ({
  type: Types.GET_INVOICE_TYPES_SUCCESS,
  payload: invoiceTypes,
});

export const getInvoices = (isPayed, isReversed) => ({
  type: Types.GET_INVOICES,
  payload: { isPayed, isReversed },
});

export const getInvoicesSuccess = (invoices) => ({
  type: Types.GET_INVOICES_SUCCESS,
  payload: invoices,
});

export const getInvoicesReset = () => ({
  type: Types.GET_INVOICES_RESET,
});

export const markInvoiceAsPayed = (ShoppingCartId, WsPayOrderId) => ({
  type: Types.MARK_INVOICE_PAYED,
  payload: { ShoppingCartId, WsPayOrderId },
});

export const invoiceError = ({ error }) => ({
  type: Types.INVOICE_ERROR,
  payload: {
    error,
  },
});
